import React from "react";

const LOGOS = [
  "paystack",
  "flutterwave",
  "moniepoint",
  "chipper",
  "kuda",
  "bamboo",
];

export default function TrustBar() {
  return (
    <section className="border-y-[1.5px] border-ink-v2 bg-white px-6 py-7 lg:px-10">
      <div className="mx-auto flex max-w-[1120px] flex-wrap items-center justify-center gap-x-10 gap-y-4 min-[600px]:justify-between">
        <span className="text-[12px] font-bold uppercase leading-none tracking-[0.12em] text-warm-500">
          Trusted by teams at
        </span>
        {LOGOS.map((logo) => (
          <span
            key={logo}
            className="text-[19px] font-extrabold lowercase leading-none tracking-[-0.02em] text-warm-400"
          >
            {logo}
          </span>
        ))}
      </div>
    </section>
  );
}
